<script>
export default {
  name: 'AuthLayout'
}
</script>

<template>
  <v-app>
    <v-main class="auth-layout">
      <div class="auth-left-panel">
        <slot />
      </div>

      <div class="auth-right-panel">
        <img
          alt="logo Boomerang"
          class="auth-logo"
          src="@/assets/images/boomerang_white_logo_baseline.png"
        />
      </div>
    </v-main>
  </v-app>
</template>

<style scoped>
.auth-layout {
  display: flex;
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 0 0 0 clamp(16px, 2.5vw, 32px);
  gap: clamp(16px, 2.5vw, 32px);
  background-color: var(--default-background-color);
}

.auth-left-panel {
  flex: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.auth-right-panel {
  flex: 1;
  position: relative;
  border-radius: var(--default-radius) 0 0 var(--default-radius);
  background-image: url('@/assets/images/login_bg.jpg');
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}

.auth-logo {
  position: absolute;
  right: clamp(10px, 1.5625vw, 20px);
  top: 50%;
  transform: translateY(-50%);
  width: clamp(341px, 34.1vw, 651px);
  max-width: calc(100% - 48px);
  height: auto;
}

@media (max-width: 1099px) {
  .auth-logo {
    width: clamp(264px, 37.2vw, 403px);
  }
}

@media (max-width: 767px) {
  .auth-layout {
    justify-content: center;
    padding: clamp(16px, 2.5vw, 32px);
  }

  .auth-right-panel {
    display: none;
  }
}
</style>
